import { memo } from 'react';
import type {
  ReactElement,
  ReactNode,
} from 'react';

import { Tooltip } from '../Tooltip';
import type {
  TooltipProps,
} from '../Tooltip';

import { renderReference } from './renderReference';

export type HintProps = Omit<TooltipProps, 'children'> & {
  className?: string;
};

function HintInner({
  className = '',
  ...rest
}: HintProps): ReactElement {
  return (
    <Tooltip
      {...rest}
    >
      {(renderProps): ReactNode => renderReference({
        ...renderProps,
        className,
      })}
    </Tooltip>
  );
}

export const Hint = memo(HintInner);
